var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.showPageRecord ? 'pagination-wrap' : ''
  }, [_c('div', {
    staticClass: "css-controls"
  }, [_c('div', {
    staticClass: "page-size-select"
  }, [_c('label', {
    attrs: {
      "for": "pageSize"
    }
  }, [_vm._v("Rows per page:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedPageSize,
      expression: "selectedPageSize"
    }],
    attrs: {
      "id": "pageSize"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedPageSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.updatedPageSize]
    }
  }, _vm._l(_vm.pageSizes, function (size) {
    return _c('option', {
      key: size,
      domProps: {
        "value": size
      }
    }, [_vm._v(_vm._s(size))]);
  }), 0)]), _vm.from && _vm.to && _vm.total && _vm.showPageRecord ? _c('div', {
    staticClass: "page-record"
  }, [_c('span', [_vm._v("Showing " + _vm._s(_vm.from) + " to " + _vm._s(_vm.to) + " of " + _vm._s(_vm.total) + " results")])]) : _vm._e()]), _vm.items.total_records > _vm.perPage ? _c('div', {
    staticClass: "table-pagination"
  }, [_vm.items.total_records > 0 ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.items.total_records,
      "per-page": _vm.perPage,
      "align": "right",
      "prev-text": "Prev",
      "next-text": "Next",
      "first-text": "First",
      "last-text": "Last"
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: _vm.items.current_page,
      callback: function callback($$v) {
        _vm.$set(_vm.items, "current_page", $$v);
      },
      expression: "items.current_page"
    }
  }) : _vm._e()], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }